import GenericValues from "@/utils/common/GenericValues.ts";
import CommonConstants from "@/utils/constants/CommonConstants.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import ActionPerformerHelper from "@/utils/moreMenu/ActionPerfomerHelper.ts";
import FieldMetaData = namaTypes.FieldMetaData;

export default class GUIActionParamsAndRow {
  private actionId: string;
  private questionFields: namaTypes.DTOFilledQuestionField[];
  private _contextRow: number = -1;
  private _parameters: namaTypes.GUIActionParameters = {};

  constructor(actionId: string, questionFields: namaTypes.DTOFilledQuestionField[]) {
    this.actionId = actionId;
    this.questionFields = questionFields;
  }

  get parameters(): namaTypes.GUIActionParameters {
    return this._parameters;
  }

  get contextRow(): number {
    return this._contextRow;
  }

  calcFieldTypeFromActionInfo(fieldId: string | undefined, questionsMetadata: namaTypes.FieldMetaData[] | undefined): string | undefined {
    if (!fieldId || !questionsMetadata)
      return;
    let matched: FieldMetaData | undefined = questionsMetadata.find(l => l.fieldId === fieldId);
    if (!matched)
      return;
    return matched.fieldType;
  }

  invoke(actionInfo: namaTypes.GUIActionInfo, helper: ActionPerformerHelper, calcFieldTypeForEachQuestionField?: boolean): GUIActionParamsAndRow {
    let contextFields: Record<string, namaTypes.GenericValue> = {};
    if (this.questionFields && this.questionFields.length) {
      for (let dtoFilledQuestionField of this.questionFields) {
        let fieldValue = dtoFilledQuestionField.objValue;
        let fieldType: string | undefined;
        if (calcFieldTypeForEachQuestionField)
          fieldType = this.calcFieldTypeFromActionInfo(dtoFilledQuestionField.id, actionInfo.questionsMetadata);
        contextFields[dtoFilledQuestionField.id!] = GenericValues.createGenericValueForType(dtoFilledQuestionField.id!, fieldValue, fieldType);
      }
    }
    let contextFieldIds = actionInfo.contextFields ?? [];
    let row = -1;
    helper.addContextFieldsToAction(contextFieldIds, -1, contextFields)
    if (CommonConstants.CONTEXTFIELD_SELECTEDLINE_INDEX in contextFields)
      row = GenericValues.getValue(contextFields[CommonConstants.CONTEXTFIELD_SELECTEDLINE_INDEX]);
    this._contextRow = row;
    this._parameters = {
      actionId: this.actionId,
      userId: LoginUtils.currentUserId(),
      entityType: helper.getEntityType(),
      barCodeOn: LoginUtils.getBarCodeOn(),
      contextFields,
      objectIndex: row,
      listViewName: helper.listViewName(),
      editViewName: helper.editViewName()
    } as namaTypes.GUIActionParameters;
    return this;
  }
}
